import API from 'util/API';


export const getInvoice = async (restaurantId, orderId) => {
  if(!restaurantId || !orderId) {
    return null;
  }

  const response = await API.get(`/invoice?restaurantId=${restaurantId}&orderId=${orderId}`);
  if (response && response.data && response.data.invoice) {
    return response.data.invoice;
  }
  return null;
};


export const fetchWechatOrderStatus = async (restaurantId, orderNo) => {
  if(!restaurantId || !orderNo) {
    console.error('missing restaurantId or orderNo');
    return null;
  }

  const response = await API.get(`/wechatPaymentStatus?restaurantId=${restaurantId}&orderNo=${orderNo}`);
  if (response && response.data && response.data.orderStatus) {
    return response.data.orderStatus;
  }
  return null;
};

// Get today's orders by type and date (legacy)
export const getTodayOrders = async (type, dateStr) => {
  const response = await API.get(`/todayOrder?type=${type}&dateStr=${dateStr}`);
  return response.data;
};

// Get orders by type and date range
export const getOrders = async (type, fromDateStr, toDateStr, tableNumber = null) => {
  let url = `/orders?type=${type}&fromDateStr=${fromDateStr}&toDateStr=${toDateStr}`;
  if (tableNumber) {
    url += `&tableNumber=${tableNumber}`;
  }
  const response = await API.get(url);
  return response.data;
};

// Delete multiple orders
export const deleteOrders = async (orderIds, type, dateStr) => {
  const formRequest = {
    ids: orderIds,
    type: type,
    dateStr: dateStr
  };
  const response = await API.put('/deleteOrders', formRequest);
  return response.data;
};


/**
 * Public order calling board for the in-store display.
 *
 * Unauthenticated on purpose - the display is a TV on a wall, not a staff
 * session. The endpoint returns order numbers only; it is gated by the clientId
 * header that `util/API` already sets on every request.
 */
export const getCallingBoard = async (restaurantId) => {
  if (!restaurantId) {
    return null;
  }

  const response = await API.get(
    `/callingBoard?restaurantId=${encodeURIComponent(restaurantId)}`
  );
  if (response && response.data) {
    return response.data;
  }
  return null;
};

/**
 * Move an order along the fulfilment lifecycle. Shares the endpoint the iPad POS
 * uses, so a status set here shows up on the POS and vice versa.
 *
 * `yearString` / `dateString` identify the Firestore day partition the order was
 * read from - pass back what `getOrders` returned rather than deriving them,
 * so an order placed just before midnight still updates the right document.
 */
export const updateOrderStatus = async ({
  orderNumber,
  yearString,
  dateString,
  status,
}) => {
  if (!orderNumber || !yearString || !dateString || !status) {
    throw new Error("orderNumber, yearString, dateString and status are required");
  }

  const response = await API.post("/pos/updateOrderStatus", {
    orderNumber,
    yearString,
    dateString,
    status,
  });
  return response.data;
};

/**
 * Today's kitchen status as each iPad POS reported it: one ticket per order sent
 * to the kitchen, with where every docket stands on the printers and the kitchen
 * display. `{ statuses, devices, serverTime }`, dates as epoch ms.
 */
export const getKitchenStatus = async ({ signal } = {}) => {
  const response = await API.get('/kitchenStatus', { signal });
  return response.data;
};
